import { render, staticRenderFns } from "./model.vue?vue&type=template&id=6be65164&scoped=true&"
import script from "./model.vue?vue&type=script&lang=js&"
export * from "./model.vue?vue&type=script&lang=js&"
import style0 from "./model.vue?vue&type=style&index=0&id=6be65164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be65164",
  null
  
)

export default component.exports